import Msg from './src/main'

export default {
  install(Vue) {
    Vue.prototype.$Msg = Msg
  }
}
